import type { Node } from "@xyflow/react";

/** When a section is selected, include direct children for chat/onboarding surfaces. */
export function expandSelectedNodesWithSectionChildren(nodes: Node[]): Node[] {
  const selected = nodes.filter((n) => n.selected);
  if (!selected.some((n) => n.type === "section")) return selected;

  const seen = new Set(selected.map((n) => n.id));
  const extra: Node[] = [];
  for (const node of selected) {
    if (node.type !== "section") continue;
    for (const child of nodes) {
      if (child.parentId === node.id && !seen.has(child.id)) {
        seen.add(child.id);
        extra.push(child);
      }
    }
  }
  return [...selected, ...extra];
}
